module.exports = __webpack_public_path__ + "static/media/rea-tile-2.43273467.png";